






import { Component, Mixins, Prop } from 'vue-property-decorator';
import { JobsListResponseData } from '@/api-v2/Jobs';
import { parseMoscowTimeAsDayjs } from '@/utils';
import TableCellClass from '@/views/Admin/Tasks/TableCellClass';

@Component
export default class TableCellStartDate extends Mixins(TableCellClass) {
  override readonly cellType = 'start-date';
  @Prop(Object) readonly item!: JobsListResponseData;

  get formattedDate(): string {
    return parseMoscowTimeAsDayjs(this.item.date_start)
      .format('DD.MM.YY');
  }
}
